import { render, staticRenderFns } from "./SuccessScreen.vue?vue&type=template&id=4e9dc789&scoped=true&"
var script = {}
import style0 from "./SuccessScreen.vue?vue&type=style&index=0&id=4e9dc789&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9dc789",
  null
  
)

export default component.exports